import DashboardButton from './DashboardButton';
import { Grid, Image, Stack, Container } from '@mantine/core';
import { IconInfoCircle, IconTable, IconDiamond, IconChevronsRight } from '@tabler/icons-react';
import InfoBanner from './registration/InfoBanner';
import tila from 'assets/lanitila2.png';
import config from 'config/config';

const Info = () => <IconInfoCircle size={24} />;
const Table = () => <IconTable size={24} />;
const Intra = () => <IconDiamond size={24} />;
const Point = () => <IconChevronsRight size={24} />;

const Dashboard: React.FC = () => {
    return (
        <>
            <Container size="md">
                <Image src={tila} alt="Lanitila" style={{ borderRadius: '8px', display: 'block', margin: '0 auto' }} />
                <Stack gap="md" mt="md">
                    <Grid gutter="md" justify="center">
                        <Grid.Col span={{ base: 12, sm: 10 }} style={{ marginTop: 20 }}>
                            {config.REGISTRATION_OPEN === 'true' && <InfoBanner />}
                        </Grid.Col>
                    </Grid>
                    <Grid gutter="md" justify="center">
                        <Grid.Col span={{ base: 12, sm: 6 }}>
                            <DashboardButton title="Infoa laneista" infoText="!!! LUE NÄMÄ !!!" url="/info" icon={Info} />
                        </Grid.Col>
                        <Grid.Col span={{ base: 12, sm: 6 }}>
                            <DashboardButton
                                title="Ilmoittautuminen"
                                infoText="Ilmoittaudu laneille"
                                url="/registration"
                                icon={Point}
                            />
                        </Grid.Col>
                    </Grid>
                    <Grid gutter="md" justify="center">
                        <Grid.Col span={{ base: 12, sm: 6 }}>
                            <DashboardButton
                                title="Pöytävaraus"
                                infoText="Tarkista varaustilanne tai muuta varaustasi"
                                url="/booking"
                                icon={Table}
                            />
                        </Grid.Col>
                        <Grid.Col span={{ base: 12, sm: 6 }}>
                            <DashboardButton
                                title="Intra"
                                infoText="Lanien aikaan materiaalipankki"
                                url="/intra"
                                icon={Intra}
                            />
                        </Grid.Col>
                    </Grid>
                </Stack>
            </Container>
        </>
    );
};

export default Dashboard;
